<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="siklu-mat-dialog-title" matDialogTitle>
    <h4>{{ 'companyTypes.popups.createOrEditLabel' | translate }}</h4>
    <button matDialogClose windeClose>
        <sui-svg-icon icon="cross"/>
    </button>
</div>
<div *ngIf="restrictions" class="siklu-mat-dialog-body" matDialogContent>
    <winde-alert-error></winde-alert-error>

    <div class="row">
        <div class="control col-6">
            <div class="control-label">{{ 'companyTypes.popups.adminUserLimit' | translate }}</div>
            <sui-number-component [config]="restrictions.adminUserLimit" class="sui-e2e-adminUserLimit"></sui-number-component>
        </div>
        <div class="control col-6">
            <div class="control-label">{{ 'companyTypes.popups.plannerUserLimit' | translate }}</div>
            <sui-number-component [config]="restrictions.plannerUserLimit" class="sui-e2e-plannerUserLimit"></sui-number-component>
        </div>
        <div class="control col-6">
            <div class="control-label">{{ 'companyTypes.popups.projectsLimit' | translate }}</div>
            <sui-number-component [config]="restrictions.projectsLimit" class="sui-e2e-projectsLimit"></sui-number-component>
        </div>
        <div class="control col-6">
            <div class="control-label">{{ 'companyTypes.popups.projectNodesLimit' | translate }}</div>
            <sui-number-component [config]="restrictions.projectLocationsLimit" class="sui-e2e-projectNodesLimit"></sui-number-component>
        </div>
        <div class="control col-6">
            <div class="control-label">{{ 'companyTypes.popups.exportEnabled' | translate }}</div>
            <sui-toggle-component [config]="restrictions.exportEnabled" class="sui-e2e-exportEnabled"></sui-toggle-component>
        </div>
    </div>
</div>
<div class="siklu-mat-dialog-footer" matDialogActions>
    <button matDialogClose windeTransparent>
        <sui-svg-icon icon="cross"/>
        {{ 'entity.action.cancel' | translate }}
    </button>
    <button (click)="save()" windeGreen>
        <sui-svg-icon icon="save"/>
        {{ 'entity.action.save' | translate }}
    </button>
</div>
